var classes = {"menuPositionWrapper":"QcCOv","menuPositionWrapperBody":"QPb4m"};

export { classes as default };
